export const isAdmin = () => conf.isAdmin
const onlyIf =
  (...conditions) =>
  () =>
    conditions.every((condition) => condition)
